import * as React from 'react';

const blockTags = ['P', 'DIV', 'LI', 'TR', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'BLOCKQUOTE'];

function isSafeLink(href: string | null): boolean {
    return Boolean(href) && /^https?:\/\//i.test((href as string).trim());
}

function appendCleaned(source: Node, target: Node, doc: Document) {
    source.childNodes.forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
            target.appendChild(doc.createTextNode(child.textContent || ''));
            return;
        }
        if (child.nodeType !== Node.ELEMENT_NODE) {
            return;
        }

        const element = child as Element;
        const tag = element.tagName;

        if (tag === 'SCRIPT' || tag === 'STYLE') {
            return;
        }
        if (tag === 'BR') {
            target.appendChild(doc.createElement('br'));
            return;
        }
        if (tag === 'A' && isSafeLink(element.getAttribute('href'))) {
            const link = doc.createElement('a');
            link.setAttribute('href', (element.getAttribute('href') as string).trim());
            link.textContent = element.textContent;
            target.appendChild(link);
            return;
        }

        appendCleaned(element, target, doc);

        if (
            blockTags.indexOf(tag) !== -1 &&
            target.lastChild &&
            target.lastChild.nodeName !== 'BR'
        ) {
            target.appendChild(doc.createElement('br'));
        }
    });
}

export function cleanPastedContent(html: string, text: string): DocumentFragment {
    const fragment = document.createDocumentFragment();

    if (!html) {
        text.split(/\r?\n/).forEach((line, index) => {
            if (index > 0) {
                fragment.appendChild(document.createElement('br'));
            }
            fragment.appendChild(document.createTextNode(line));
        });
        return fragment;
    }

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    appendCleaned(parsed.body, fragment, document);

    while (fragment.lastChild && fragment.lastChild.nodeName === 'BR') {
        fragment.removeChild(fragment.lastChild);
    }
    return fragment;
}

export function pasteAsTextWithLinks(event: React.ClipboardEvent<HTMLElement>) {
    event.preventDefault();

    const fragment = cleanPastedContent(
        event.clipboardData.getData('text/html'),
        event.clipboardData.getData('text/plain')
    );

    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
        event.currentTarget.appendChild(fragment);
        return;
    }

    const range = selection.getRangeAt(0);
    range.deleteContents();
    const lastInserted = fragment.lastChild;
    range.insertNode(fragment);
    if (lastInserted) {
        range.setStartAfter(lastInserted);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
    }
}
